import React from "react";
import { useSelector } from "react-redux";
import SectionHeading from "@components/sectionHeading";
import { ContactLink } from "../components/ContactLink";
import Button from "@components/button";
import { themes } from "@theme/config";
import { removeIdFromQueryString } from "@containers/Tracking/helpers";

export const DeclineApplicationExpired = () => {
  const { themeName } = useSelector((state) => state.StartUp.theme);
  const queryString = useSelector((state) => state.StartUp.queryString);

  let href = '/apply';
  if (themeName === themes.fgfParent.rent.themeName) {
    const string = removeIdFromQueryString(queryString);
    href = `/apply?${string}`
  }

  return (
    <SectionHeading
      heading="Application Expired...."
      className="margin-bottom capitalise"
      soft
      subheading={(
        <>
          Sorry your application has expired. Please click on the button below to start a new application.<br /><br />
          Alternatively, if you want to resume your previous application, please
          contact us on <ContactLink />.
          <Button elementType="a" href={href} className="margin-bottom apply-link">Start Application</Button>
        </>
      )}
    />
  );
};